<template>
  <div>
    <order-cart
      ref="cart"
      v-model:delivery-charge="quote.delivery_charge"
      v-model:items="quote.skus"
      v-model:pickup-charge="quote.pickup_charge"
      delivery-required
      rearrangeable
      :reference-items="order.skus"
      :taxes="taxes"
      :units="units"
      :validate="priceRequired"
      validate-units
      :with-cost-codes="false"
      with-prices
    >
      <template v-slot:title:append>
        <slot name="order-cart-title-append" />
      </template>
      <template v-slot:items:prepend-left>
        <slot name="order-cart-items-prepend-left" />
      </template>
      <template v-slot:items>
        <slot name="order-cart-items" />
      </template>
      <v-row align="center" class="mt-3" justify="end">
        <v-col class="text-dark-grey text-right">
          <order-total-price-estimate
            :delivery-charge="quote.delivery_charge"
            :delivery-required="order.delivery_required"
            :freight-tax="order.freight_tax"
            :pickup-charge="quote.pickup_charge"
            :skus="quote.skus"
            :model-value="quote.total_price"
          />
        </v-col>
      </v-row>
    </order-cart>
    <div v-if="!noMatch && order.orderType?.fromBom">
      <v-row v-if="itemsAreMatched" class="mt-3">
        <v-col class="text-right">
          <qtm-btn secondary size="x-large" @click="$emit('update:show-match-items-dialog', true)">
            Match items
          </qtm-btn>
        </v-col>
      </v-row>
      <match-items-dialog
        v-model:items-to-match="quote.skus"
        :model-value="showMatchItemsDialog"
        item-type="Quote"
        :items-to-match-header="quote.vendor?.name ?? ''"
        match-item-type="Quote Request"
        :match-items="order.skus"
        :match-items-header="order.reference_name!"
        single-match
        :order-id="order.id"
        :units="units"
        with-progress
        @update:model-value="$emit('update:show-match-items-dialog', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Order, Quote } from '@quotetome/materials-api'
import MatchItemsDialog from '@/components/items/match-items-dialog.vue'
import OrderCart from '@/components/orders/order-cart.vue'
import OrderTotalPriceEstimate from '@/components/orders/order-total-price-estimate.vue'

export interface Props {
  itemsAreMatched?: boolean
  noMatch: boolean
  order: Order
  quote: Quote
  showMatchItemsDialog?: boolean
  taxes?: any[]
  units?: any[]
}

const props = withDefaults(defineProps<Props>(), {
  taxes: () => [],
  units: () => [],
})

defineEmits(['update:show-match-items-dialog'])

const cart = ref<typeof OrderCart>()
const priceRequired = computed(() => props.quote.response_received === 'price given')

const clear = () => cart.value?.clear()
const isValid = () => cart.value?.isValid()

defineExpose({ clear, isValid })
</script>
